import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-screen flex items-center justify-center bg-sand-50 px-6">
      <div className="w-full max-w-md bg-white p-8 md:p-10 shadow-soft rounded-lg">
        <p className="text-xs uppercase tracking-[0.3em] text-terracotta mb-3">Khalfan Oman</p>
        <h1 className="font-serif-display text-3xl text-charcoal mb-8">{t.admin.login}</h1>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label htmlFor="email">{t.admin.email}</Label>
            <Input id="email" data-testid="admin-login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2" required />
          </div>
          <div>
            <Label htmlFor="password">{t.admin.password}</Label>
            <Input id="password" data-testid="admin-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2" required />
          </div>
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={busy}
            className="w-full bg-charcoal text-sand-50 rounded-full py-3 hover:bg-charcoal-600 disabled:opacity-60 transition"
          >
            {busy ? "…" : t.admin.signin}
          </button>
        </form>
      </div>
    </div>
  );
}
